import { Company } from "types";
import { pappersSearchApiClient } from "./client";

export const searchCompany = async (query: string) =>
  (
    await pappersSearchApiClient.get<{ resultats_siret: Company[] }>("", {
      params: { q: query, cibles: "siret" },
    })
  ).data.resultats_siret;
